// for PROD
export const API_SERVER = 'https://pulpo.api.pretii.lat'

// for DEV
//export const API_SERVER = 'http://localhost:8080'


export const paymetMethod = {
  paypal :     'PayPal (suscripción automática)',   // Task007: paypal = cobro automático, no hay link que mandar
  openpay :    'Openpay (link)',
  dlocal :     'dLocal Go (link)',
  recurrente : 'Recurrente (link)',
  crypto :     'Cripto',
  bank:        'Transferencia bancaria'
}

export const mainColor = '#3f82f9'